import { HOMEPAGE_PAGE_IDS, PAGE_TYPES } from "~constants";

export default function pageType(pageId: string) {
    let calculatedPageType = PAGE_TYPES.default;

    if (HOMEPAGE_PAGE_IDS.includes(pageId)) {
        calculatedPageType = PAGE_TYPES.home;
    }

    return {
        data: calculatedPageType,
    };
}
